import ButtonContainer from "@components/ButtonContainer";
import Select from "@components/EasyDev/form/Select";
import Loader from "@components/Loader";
import FileUpload from "@components/Shared/FileUpload";
import FormTextareaField from "@components/Shared/FormTextareaField";
import FormTextField from "@components/Shared/FormTextField";
import SelectedArtistDisplay from "@components/Shared/SelectedArtistsDisplay";
import { getLabelName } from "@helpers/artist.helper";
import useGetSelectArtists from "@hooks/Artist/useGetSelectArtists";
import IPartner from "@interfaces/partner";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";
import { Col } from "reactstrap";
import styles from "./ModifyForm.module.scss";

interface IModifyForm extends IFormProps {
  data: IPartner;
}

const ModifyForm = ({ handleSubmit, data }: IModifyForm): ReactElement => {
  const { data: artists, loading } = useGetSelectArtists();

  if (loading || !artists) {
    return <Loader isInsideThing />;
  }

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <Col md={6}>
        <div className="form__form-group">
          <span className="form__form-group-label">Name</span>
          <div className="form__form-group-field">
            <Field
              name="name"
              component={FormTextField}
              type="text"
              placeholder={"Partner's Name"}
              initialValue={data?.name}
              isAboveError
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Description</span>
          <div className="form__form-group-field">
            <Field
              name="description"
              component={FormTextareaField}
              type="text"
              placeholder={"Enter a Description"}
              initialValue={data?.description}
              isAboveError
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Order</span>
          <div className="form__form-group-field">
            <Field
              name="order"
              component={FormTextField}
              type="number"
              initialValue={data?.order}
              isAboveError
            />
          </div>
        </div>

        <FileUpload
          title="Logo"
          isSingle
          initialData={data}
          formFieldName="imageUrl"
        />

        <FileUpload
          title="Hero"
          isSingle
          initialData={data}
          formFieldName="heroImageUrl"
        />
      </Col>

      <Col md={6}>
        <div className="form__form-group">
          <span className={styles.artist}>Select Artists</span>
          <div className="form__form-group-field">
            <Field
              name="artist"
              component={Select}
              placeholde="Enter Artist"
              isAboveError
              options={artists}
            />
          </div>
        </div>

        <SelectedArtistDisplay
          initialArtists={data?.artists?.map(
            ({ displayName, walletAddress }) => ({
              value: walletAddress,
              label: getLabelName(walletAddress, displayName),
            })
          )}
        />
      </Col>

      <ButtonContainer />
    </form>
  );
};

export default ModifyForm;
